export const failure = {
  doesNotExists: "DOES_NOT_EXISTS", //doesn't exists
  undefined: "UNDEFINED" //doesn't exists yet
}